import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

export const getAgreement = (terrace) => {
  return hMacAjax.get(
    baseURL + '/grt-user-center-service/open/privacy/agreement/new/version/info?terrace=' + terrace
  );
};
